import {
  createContext,
  useMemo,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction, ReactElement,
} from 'react';

export interface SidebarContextType {
  showSidebar: boolean;
  setShowSidebar: Dispatch<SetStateAction<boolean>>
}

export const SidebarContext = createContext<SidebarContextType>({
  showSidebar: false,
  setShowSidebar: () => {},
});

interface SidebarProviderProps {
  children: ReactNode;
}

const SidebarProvider = ({ children }: SidebarProviderProps): ReactElement => {
  const [showSidebar, setShowSidebar] = useState<boolean>(false);

  const contextValue = useMemo((
    () => ({
      showSidebar,
      setShowSidebar,
    }
    )), [showSidebar]);

  return (
    <SidebarContext.Provider value={contextValue}>
      {children}
    </SidebarContext.Provider>
  );
};

export default SidebarProvider;
